export const PHONE_CODE_WIDTH = {
  1: 93,
  2: 105,
  3: 113,
  4: 120,
}

export const CODE_ID = 'code'
